import { Box } from "@mui/material";
import React from "react";
export default function NoImageFoundDocument(props: any) {
  return (
    <Box
    // style={{
    //   marginRight: "-3.5vh",
    //   marginLeft: "0vh",
    //   width: "17em",
    // }}
    >
      <div
        className="UploadImageCmp"
        style={
          props.border
            ? { textAlign: "center", marginLeft: "-10px", border: props.border }
            : { textAlign: "center", marginLeft: "-10px" }
        }
      >
        <>
          <a target="_blank" href="/images/noImageFound.svg">
            <img
              src="/images/noImageFound.svg"
              alt="Forest"
              className="uploadImage verticalImageloadDocument "
              style={{ marginLeft: "-10px" }}
            />
          </a>
        </>
      </div>
    </Box>
  );
}
